class MonsterCartProtection {
  constructor() {
    this.MAX_CLONED_QUANTITY = 2;
    var self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        self.setupEventListeners();
      });
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    var self = this;
    
    document.addEventListener('cart:updated', function() {
      setTimeout(function() {
        self.validateCartContents();
        self.setupQuantityControllers();
      }, 100);
    });

    window.addToCartCallBack = function(item, items) {
      setTimeout(function() {
        self.validateCartContents();
        self.setupQuantityControllers();
      }, 100);
    };

    var originalRefresh = window.monster_refresh;
    if (typeof originalRefresh === 'function') {
      window.monster_refresh = function(open, callback) {
        var result = originalRefresh.call(this, open, callback);
        setTimeout(function() {
          self.validateCartContents();
          self.setupQuantityControllers();
        }, 100);
        return result;
      };
    }
    setTimeout(function() {
      self.validateCartContents();
      self.setupQuantityControllers();
    }, 1000);
  }

  setupQuantityControllers() {
    var itemsContainer = document.querySelector('#monster-upsell-cart #mu-items-container');
    if (!itemsContainer) return;

    var cartItems = itemsContainer.querySelectorAll('.mu-cart-item');
    var self = this;
    
    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      var titleLink = cartItem.querySelector('.mu-item-title a');
      if (!titleLink) continue;

      var href = titleLink.getAttribute('href');
      var isClonedProduct = href && href.indexOf('monster') !== -1;

      if (isClonedProduct) {
        self.controlClonedProductQuantity(cartItem);
      }
    }
  }

  controlClonedProductQuantity(cartItem) {
    var quantityContainer = cartItem.querySelector('.mu-item-quantity');
    if (!quantityContainer) return;

    var self = this;
    var quantityInputs = quantityContainer.querySelectorAll('input[type="number"]');
    var plusBtn = quantityContainer.querySelector('button[aria-label*="increase"], button:last-child');

    function updatePlusBtnState() {
      var maxReached = false;
      for (var i = 0; i < quantityInputs.length; i++) {
        var input = quantityInputs[i];
        var value = parseInt(input.value) || 1;
        if (value >= 2) maxReached = true;
      }
      if (plusBtn) {
        plusBtn.disabled = maxReached;
        if (maxReached) {
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.classList.remove('disabled');
        }
        plusBtn.style.opacity = maxReached ? '0.5' : '';
        plusBtn.style.pointerEvents = maxReached ? 'none' : '';
      }
    }

    for (var i = 0; i < quantityInputs.length; i++) {
      var input = quantityInputs[i];
      input.setAttribute('min', '1');
      input.setAttribute('max', self.MAX_CLONED_QUANTITY);

      input.addEventListener('input', function(e) {
        var value = parseInt(e.target.value) || 1;
        if (value < 1) value = 1;
        if (value > self.MAX_CLONED_QUANTITY) value = self.MAX_CLONED_QUANTITY;
        if (e.target.value != value) {
          e.target.value = value;
          self.showNotification('Maximum ' + self.MAX_CLONED_QUANTITY + ' units allowed for discounted items.', 'warning');
        }
        updatePlusBtnState();
      });
      
      input.addEventListener('change', function(e) {
        var value = parseInt(e.target.value) || 1;
        if (value < 1) value = 1;
        if (value > self.MAX_CLONED_QUANTITY) value = self.MAX_CLONED_QUANTITY;
        if (e.target.value != value) {
          e.target.value = value;
        }
        updatePlusBtnState();
      });
      
      var value = parseInt(input.value) || 1;
      if (value < 1) value = 1;
      if (value > self.MAX_CLONED_QUANTITY) value = self.MAX_CLONED_QUANTITY;
      if (input.value != value) {
        input.value = value;
      }
    }
    updatePlusBtnState();
  }

  async validateCartContents() {
    try {
      const domItems = this.getCartItemsFromDOM();
      const apiItems = await this.getCartItems();
      
      const cartData = domItems.length > 0 ? { items: domItems } : apiItems;
      
      if (!cartData || !cartData.items || cartData.items.length === 0) {
        return;
      }

      const { mainProducts, clonedProducts } = this.categorizeProducts(cartData.items);
      
      if (mainProducts.length === 0 && clonedProducts.length > 0) {
        await this.removeClonedProductsFromDOM();
        return;
      }

      this.limitClonedProductQuantitiesInDOM();
      
    } catch (error) {
    }
  }

  getCartItemsFromDOM() {
    var itemsContainer = document.querySelector('#monster-upsell-cart #mu-items-container');
    if (!itemsContainer) return [];

    var cartItems = itemsContainer.querySelectorAll('.mu-cart-item');
    var items = [];

    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      var titleLink = cartItem.querySelector('.mu-item-title a');
      var quantityInput = cartItem.querySelector('.mu-item-quantity input[type="number"]');
      
      if (titleLink && quantityInput) {
        var href = titleLink.getAttribute('href');
        var title = titleLink.textContent.trim();
        var quantity = parseInt(quantityInput.value) || 1;
        
        var handle = '';
        if (href) {
          var urlParts = href.split('/products/');
          if (urlParts.length > 1) {
            handle = urlParts[1].split('?')[0];
          }
        }

        items.push({
          product_title: title,
          handle: handle,
          quantity: quantity,
          href: href,
          domElement: cartItem
        });
      }
    }

    return items;
  }

  limitClonedProductQuantitiesInDOM() {
    var itemsContainer = document.querySelector('#monster-upsell-cart #mu-items-container');
    if (!itemsContainer) return;

    var cartItems = itemsContainer.querySelectorAll('.mu-cart-item');
    var self = this;
    
    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      var titleLink = cartItem.querySelector('.mu-item-title a');
      var quantityInput = cartItem.querySelector('.mu-item-quantity input[type="number"]');
      
      if (!titleLink || !quantityInput) continue;

      var href = titleLink.getAttribute('href');
      var isClonedProduct = href && href.indexOf('monster') !== -1;
      
      if (isClonedProduct) {
        var currentQuantity = parseInt(quantityInput.value) || 1;
        
        if (currentQuantity > self.MAX_CLONED_QUANTITY) {
          quantityInput.value = self.MAX_CLONED_QUANTITY;
          
          var changeEvent = document.createEvent('Event');
          changeEvent.initEvent('change', true, true);
          quantityInput.dispatchEvent(changeEvent);
          
          self.showNotification('Discounted item "' + titleLink.textContent + '" limited to ' + self.MAX_CLONED_QUANTITY + ' units maximum.', 'info');
        }
      }
    }
  }

  async removeClonedProductsFromDOM() {
    var itemsContainer = document.querySelector('#monster-upsell-cart #mu-items-container');
    if (!itemsContainer) return;

    var cartItems = itemsContainer.querySelectorAll('.mu-cart-item');
    var clonedItems = [];
    
    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      var titleLink = cartItem.querySelector('.mu-item-title a');
      if (!titleLink) continue;

      var href = titleLink.getAttribute('href');
      var isClonedProduct = href && href.indexOf('monster') !== -1;
      
      if (isClonedProduct) {
        clonedItems.push({
          element: cartItem,
          title: titleLink.textContent.trim()
        });
      }
    }

    for (var j = 0; j < clonedItems.length; j++) {
      var item = clonedItems[j];
      try {
        var removeBtn = item.element.querySelector('.mu-remove-bin, .mu-remove-item');
        if (removeBtn) {
          removeBtn.click();
        }
      } catch (error) {
      }
    }
    
    this.showNotification('Discounted items removed as main products are no longer in cart.', 'warning');
  }

  categorizeProducts(items) {
    var mainProducts = [];
    var clonedProducts = [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var isClonedProduct = (item.handle && item.handle.toLowerCase().indexOf('monster') !== -1) ||
                           (item.href && item.href.indexOf('monster') !== -1) ||
                           (item.product_title && item.product_title.toLowerCase().indexOf('monster') !== -1);
      
      if (isClonedProduct) {
        clonedProducts.push(item);
      } else {
        mainProducts.push(item);
      }
    }

    return { mainProducts: mainProducts, clonedProducts: clonedProducts };
  }

  async getCartItems() {
    try {
      if (typeof window.monster_getCartItems === 'function') {
        return await window.monster_getCartItems();
      }
      
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async removeClonedProducts(clonedProducts) {
    for (const product of clonedProducts) {
      try {
        if (typeof window.monster_removeCartItem === 'function') {
          window.monster_removeCartItem(product.variant_id || product.id);
        } else {
          await this.updateProductQuantity(product.key, 0);
        }
        
      } catch (error) {
      }
    }

    this.refreshCartDisplay();
    
    this.showNotification('Discounted items removed as main products are no longer in cart.', 'warning');
  }

  async limitClonedProductQuantities(clonedProducts) {
    for (const product of clonedProducts) {
      if (product.quantity > this.MAX_CLONED_QUANTITY) {
        try {
          if (typeof window.monster_updateCartItem === 'function') {
            window.monster_updateCartItem(product.variant_id || product.id, this.MAX_CLONED_QUANTITY);
          } else {
            await this.updateProductQuantity(product.key, this.MAX_CLONED_QUANTITY);
          }
          
          this.showNotification(`Discounted item "${product.product_title}" limited to ${this.MAX_CLONED_QUANTITY} units maximum.`, 'info');
          
        } catch (error) {
        }
      }
    }
  }

  async updateProductQuantity(lineKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  refreshCartDisplay() {
    if (typeof window.monster_refresh === 'function') {
      window.monster_refresh(false);
    }
    
    var cartEvent;
    if (typeof CustomEvent === 'function') {
      cartEvent = new CustomEvent('cart:updated', {
        detail: { source: 'monster-cart-protection' }
      });
    } else {
      cartEvent = document.createEvent('CustomEvent');
      cartEvent.initCustomEvent('cart:updated', true, true, { source: 'monster-cart-protection' });
    }
    document.dispatchEvent(cartEvent);
  }

  showNotification(message, type) {
    if (typeof type === 'undefined') type = 'info';
    
    var existingNotification = document.querySelector('.cart-notification, .notification, .alert');
    
    if (existingNotification) {
      var messageElement = existingNotification.querySelector('.notification-message, .alert-message, .message');
      if (messageElement) {
        messageElement.textContent = message;
        existingNotification.classList.add('active', 'visible');
        
        setTimeout(function() {
          existingNotification.classList.remove('active', 'visible');
        }, 5000);
        return;
      }
    }

    var notification = document.createElement('div');
    notification.className = 'monster-cart-notification monster-cart-notification--' + type;
    notification.innerHTML = '<div class="monster-cart-notification__content">' +
      '<span class="monster-cart-notification__message">' + message + '</span>' +
      '<button class="monster-cart-notification__close" onclick="this.parentElement.parentElement.remove()">×</button>' +
      '</div>';
    
    notification.style.cssText = 
      'position: fixed;' +
      'top: 20px;' +
      'right: 20px;' +
      'z-index: 10000;' +
      'background: ' + (type === 'warning' ? '#ff9800' : '#2196f3') + ';' +
      'color: white;' +
      'padding: 15px 20px;' +
      'border-radius: 5px;' +
      'box-shadow: 0 4px 6px rgba(0,0,0,0.1);' +
      'max-width: 400px;' +
      'font-size: 14px;' +
      'line-height: 1.4;' +
      'animation: slideInRight 0.3s ease-out;';
    
    document.body.appendChild(notification);
    
    setTimeout(function() {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 5000);
  }

  destroy() {
    this.isInitialized = false;
  }
}

var style = document.createElement('style');
style.textContent = 
  '@keyframes slideInRight {' +
    'from {' +
      'transform: translateX(100%);' +
      'opacity: 0;' +
    '}' +
    'to {' +
      'transform: translateX(0);' +
      'opacity: 1;' +
    '}' +
  '}' +
  
  '.monster-cart-notification__content {' +
    'display: flex;' +
    'align-items: center;' +
    'justify-content: space-between;' +
    'gap: 10px;' +
  '}' +
  
  '.monster-cart-notification__close {' +
    'background: none;' +
    'border: none;' +
    'color: inherit;' +
    'font-size: 18px;' +
    'cursor: pointer;' +
    'padding: 0;' +
    'width: 20px;' +
    'height: 20px;' +
    'display: flex;' +
    'align-items: center;' +
    'justify-content: center;' +
    'border-radius: 50%;' +
    'opacity: 0.8;' +
  '}' +
  
  '.monster-cart-notification__close:hover {' +
    'opacity: 1;' +
    'background-color: rgba(255,255,255,0.2);' +
  '}';
document.head.appendChild(style);

var monsterCartProtection = new MonsterCartProtection();

window.addToCartCallBack = function(item, items) {
  setTimeout(() => {
    monsterCartProtection.validateCartContents();
  }, 300);
};

window.mu_custom_atc_logic = function() {
  var productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
  if (!productForm) return true;
  
  var variantIdInput = productForm.querySelector('input[name="id"]');
  var quantityInput = productForm.querySelector('input[name="quantity"]');
  
  if (!variantIdInput) return true;
  
  var variantId = variantIdInput.value;
  var quantity = parseInt(quantityInput ? quantityInput.value : 1) || 1;
  
  var productData = window.productData || {};
  var productHandle = productData.handle || '';
  
  if (productHandle.toLowerCase().indexOf('monster') !== -1) {
    monsterCartProtection.getCartItems().then(function(cartData) {
      if (cartData && cartData.items) {
        var categorized = monsterCartProtection.categorizeProducts(cartData.items);
        var mainProducts = categorized.mainProducts;
        
        if (mainProducts.length === 0) {
          alert('You must have regular products in your cart before adding discounted items.');
          return false;
        }
        
        if (quantity > monsterCartProtection.MAX_CLONED_QUANTITY) {
          alert('You can only add a maximum of ' + monsterCartProtection.MAX_CLONED_QUANTITY + ' units of this discounted item.');
          
          if (quantityInput) {
            quantityInput.value = monsterCartProtection.MAX_CLONED_QUANTITY;
          }
          return false;
        }
      }
    });
  }
  
  return true;
};

window.mu_custom_checkout = async function() {
  try {
    var cartData = await monsterCartProtection.getCartItems();
    
    if (cartData && cartData.items) {
      var categorized = monsterCartProtection.categorizeProducts(cartData.items);
      var mainProducts = categorized.mainProducts;
      var clonedProducts = categorized.clonedProducts;
      
      if (mainProducts.length === 0 && clonedProducts.length > 0) {
        alert('Cannot proceed to checkout. Discounted items require regular products in your cart.');
        
        await monsterCartProtection.removeClonedProducts(clonedProducts);
        return false;
      }
      
      var hasViolations = false;
      for (var i = 0; i < clonedProducts.length; i++) {
        if (clonedProducts[i].quantity > monsterCartProtection.MAX_CLONED_QUANTITY) {
          hasViolations = true;
          break;
        }
      }
      
      if (hasViolations) {
        alert('Some discounted items exceed the maximum quantity of ' + monsterCartProtection.MAX_CLONED_QUANTITY + '. Please adjust quantities before checkout.');
        
        await monsterCartProtection.limitClonedProductQuantities(clonedProducts);
        return false;
      }
    }
  } catch (error) {
  }
  
  return false;
};